
<template>
    <div>
        <div class="card p-4">
            <!-- <h3>Sistema de Recursos Federales Transferidos</h3> -->
            <div class="col-12 mt-2 px-0">
                <div>
                    <a :href="urlServe + 'rendicion-ctas/informes-SRFT/Municipios/2022/SH.docx'" target="_blank">
                    <span class="contenido-titulo">- Comunicado 2022 - Cambios en Destino del Gasto del Sistema de Recursos Federales Transferidos (SRFT)</span>
                        <i class="fas fa-file-word icono-archivo icon-word"></i>
                    </a>
                </div><br></br>
                <div>
                    <a :href="urlServe + 'rendicion-ctas/informes-SRFT/Municipios/2024/informacion/Guia-Criterios-ID.pdf'" target="_blank">
                    <span class="contenido-titulo">- Guía de Criterios para el Reporte del Informe Definitivo 2024 y del Segundo Informe Trimestral 2025</span>
                        <i class="fas fa-file-pdf icono-archivo icon-pdf"></i>
                    </a>
                </div><br></br>
                <div>
                    <a :href="urlServe + 'rendicion-ctas/informes-SRFT/Municipios/2026/informacion/Lin-RFT.doc'" target="_blank">
                    <span class="contenido-titulo">- Lineamientos aplicables al ciclo de gestión de los recursos federales transferidos a las entidades federativas, los municipios y las demarcaciones territoriales de la Ciudad de México (Lineamientos RFT)</span>
                        <i class="fas fa-file-word icono-archivo icon-word"></i>
                    </a>
                </div><br></br>
                <div>
                    <a :href="urlServe + 'rendicion-ctas/informes-SRFT/Municipios/2026/informacion/Oficio-419.pdf'" target="_blank">
                    <span class="contenido-titulo">- OFICIO No. 419/UPER/2026/033 DE LA SCHP</span>
                        <i class="fas fa-file-pdf icono-archivo icon-pdf"></i>
                    </a>
                </div><br></br>
                <div class="mt-3">
                    <label class="labelTextarea">Seleccione la opción a consultar</label>
                    <px-select idSelect="opc_srft" placeholder="Seleccione opción a consultar" :options="opcionesSRFT" @KuramaSelect="opcSeleccionada = $event"></px-select>
                </div>
            </div>
            <div v-if="opcSeleccionada" class="mt-5">
                <h4>{{opcSeleccionada.value == 1? 'Municipios' : 'Organismos Públicos'}}</h4>
                <select3Filtros id="selectFiltroSRFT" :data="data" @seleccionado="responseSelectComponent = $event" @titulo="textoTitulo = $event" @fecha="fecha_actualizacion_anio = $event" :placeholder1="'Año'" :placeholder2="'Trimestre'" />
            </div>
        </div>
        <!-- {{ responseSelectComponent }} -->
        <div v-if="dataPorAnioyTrim && dataPorAnioyTrim.length > 0" class="px-2">
            <card-collapse-docs :sections="dataPorAnioyTrim[0].contenido_seccion" :urlServe="urlServe" :filtros="2"/>
        </div>
        <div class="m-3"><span v-html="fecha_actualizacion"></span></div>

    </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import SRFT from "@/services/rendicionDeCuentas/presupuestosEgresos/presupuestoEgresos.js"
const _serviciosSRFT= new SRFT();
import botonAtras from '../../button-atras.vue';
import select3Filtros from '@/components/selectCompuesto3.vue'
import cardCollapseDocs from '@/components/cardcollapseSubs.vue';
import DateFormat from "@/mixins/dateFormatMixin.js";

export default {
    mixins: [DateFormat],
    components: {botonAtras, select3Filtros, cardCollapseDocs},
    created(){
    },
    data(){
        return{
            opcionesSRFT: [ { id: 1, value: 1, text: "Municipios"}, { id: 2, value: 2, text: "Organismos Públicos"} ],
            opcSeleccionada: null,
            data: [],
            responseSelectComponent: { select: "", selectedSeccion: { id: 0, text: "", fecha_actualizacion:'' } },
            dataAll: [],
            textoTitulo: '',
            dataPorAnioyTrim: [],
            fecha_actualizacion: '',
            fecha_actualizacion_anio: ''
        }
    },
    methods:{
        async getAniosYtrim() {
            try {
                const response = this.opcSeleccionada.value == 1? await _serviciosSRFT.getListadoAniosTrimMunicipios(mapFun.SRFTMpiosMenu) : await _serviciosSRFT.getListadoAniosTrimOP(mapFun.SRFTOPMenu);
                this.fecha_actualizacion = this.DateFormatText(response.data[response.data.length - 1].fecha_actualizacion);
                this.data = response.data.reverse(); //para mostrar los años actuales primeros
                this.data = this.data.map(function (e) {
                return {
                    id:       e.id,
                    text:     e.titulo,
                    fecha_actualizacion: e.fecha_actualizacion,
                    seccion:  e.contenido
                };
              });
            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getAllContenido() {
            try {
                let anio_seleccionado = this.responseSelectComponent.select;
                let ruta = this.opcSeleccionada.value == 1? mapFun.SRFTMpiosContenido : mapFun.SRFTOPContenido;
                let ruta_completa = ruta+anio_seleccionado+".json";
                // console.log("ruta_completa!!!!!!!!!!!!", ruta_completa)
                const response = this.opcSeleccionada.value == 1? await _serviciosSRFT.getAllContenidoSRFTM(ruta_completa) : await _serviciosSRFT.getAllContenidoSRFTOP(ruta_completa);
                this.dataAll = response.data;
            } catch (error) {
                console.log('error', error.message);
            }
        },
        getAllContenidoByTrim(){
            this.dataAll.forEach(element => {
                this.dataPorAnioyTrim = element.secciones.filter(itemsec => itemsec.id_seccion == this.responseSelectComponent.selectedSeccion.id);
            });
        }
    },
    watch:{
        opcSeleccionada(){
            this.getAniosYtrim();
            this.data = [];
            this.dataPorAnioyTrim = [];
        },
        'responseSelectComponent.select'(){
            if(this.responseSelectComponent.select != ''){this.getAllContenido();}
        },
        async dataAll(){
            await this.getAllContenidoByTrim();
        },
        async 'responseSelectComponent.selectedSeccion.id'(){
            if(this.responseSelectComponent.selectedSeccion){
                await this.getAllContenidoByTrim();
                if(this.responseSelectComponent.selectedSeccion.fecha_actualizacion){this.fecha_actualizacion = this.DateFormatText(this.responseSelectComponent.selectedSeccion.fecha_actualizacion);}
            }
        },
        fecha_actualizacion_anio(){
            if(this.fecha_actualizacion_anio != ''){
                this.fecha_actualizacion = this.DateFormatText(this.fecha_actualizacion_anio);
            }
        }
    }
}
</script>
<style scoped>
.card{border: none;}
.contenido-titulo {
  flex: 1;
  margin-right: 10px;
  font-size: 1rem;
}
.item-name .pie-titulo,
.titulo .pie-titulo{
  font-size: .8rem;
  font-style: italic;
  color:#a1a1a1;
  margin-left: 10px;
}
.icons {
    display: flex;
    gap: 10px;
    font-size: 1.5rem;
}
.children .icons {
    display: flex;
    gap: 10px;
    font-size: 1rem;
}
.icons a {
    color: #000;
    transition: color 0.2s;
}
.icons a:hover {
    color: #007bff;
}
.icon-pdf{
    color: #e74c3c!important;
}
.icon-word {
    color: #007bff!important;
}
.icon-excel {
    color: #28a745!important;
}
.icon-rar {
    color: #f39c12!important;
}
.icono-archivo{
    font-size: 1.2rem;
}
</style>